module.exports = __webpack_public_path__ + "img/ic_end_call_hover.0e3a5a2b.svg";